import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative bg-gradient-to-br from-primary via-secondary to-primary min-h-[40vh] sm:min-h-[45vh] flex items-center px-4 sm:px-6 overflow-hidden py-2 sm:py-3">
      {/* Enhanced background effects */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-10 left-10 w-48 h-48 sm:w-72 sm:h-72 md:w-96 md:h-96 bg-white rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-64 h-64 sm:w-96 sm:h-96 md:w-[500px] md:h-[500px] bg-accent rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-32 h-32 sm:w-48 sm:h-48 md:w-64 md:h-64 bg-white rounded-full blur-2xl"></div>
      </div>

      {/* Decorative pattern overlay */}
      <div className="absolute inset-0 opacity-5" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)', backgroundSize: '40px 40px' }}></div>

      <div className="relative max-w-7xl mx-auto w-full">
        <div className="flex flex-col items-center text-center space-y-2 sm:space-y-3 md:space-y-4">
          {/* Enhanced logo with glow effect - Minimal top spacing */}
          <div className="relative">
            <div className="absolute inset-0 bg-white/30 rounded-2xl sm:rounded-3xl blur-xl sm:blur-2xl"></div>
            <div className="relative flex items-center justify-center w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-48 bg-white rounded-2xl sm:rounded-3xl shadow-2xl transform hover:scale-110 transition-transform duration-300">
              <Icon name="Zap" size={80} className="sm:hidden text-primary" />
              <Icon name="Zap" size={100} className="hidden sm:block md:hidden text-primary" />
              <Icon name="Zap" size={120} className="hidden md:block text-primary" />
            </div>
          </div>

          {/* Enhanced heading with better contrast */}
          <div className="space-y-1 sm:space-y-2 md:space-y-3 px-2">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-extrabold text-white leading-tight drop-shadow-lg">
              Descuentos Exclusivos con<br />
              <span className="text-accent drop-shadow-2xl">Escaneo QR</span>
            </h1>
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white font-semibold max-w-3xl mx-auto drop-shadow-md">
              Únete a la comunidad comercial que revoluciona cómo obtienes descuentos en Colombia
            </p>
            <p className="text-sm sm:text-base md:text-lg text-white/95 max-w-2xl mx-auto">
              Miles de usuarios ya están ahorrando hasta 50% en sus compras favoritas
            </p>
          </div>

          {/* Enhanced CTA buttons with corrected navigation */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 md:gap-5 w-full sm:w-auto pt-0 sm:pt-1 px-4 sm:px-0">
            <Button
              variant="default"
              size="lg"
              iconName="User"
              iconPosition="left"
              onClick={() => navigate('/user-registration')}
              className="bg-white text-primary hover:bg-white/95 hover:shadow-2xl min-w-full sm:min-w-[200px] md:min-w-[220px] font-bold text-base sm:text-lg py-4 sm:py-5 md:py-6 transform hover:scale-105 transition-all duration-300 shadow-xl"
            >
              Registro Usuario
            </Button>
            <Button
              variant="outline"
              size="lg"
              iconName="Briefcase"
              iconPosition="left"
              onClick={() => navigate('/business-registration')}
              className="border-3 sm:border-4 border-white text-white hover:bg-white hover:text-primary min-w-full sm:min-w-[200px] md:min-w-[220px] font-bold text-base sm:text-lg py-4 sm:py-5 md:py-6 transform hover:scale-105 transition-all duration-300 backdrop-blur-sm bg-white/10 shadow-xl"
            >
              Registro Empresa
            </Button>
          </div>

          {/* Enhanced trust indicators - Minimal bottom spacing */}
          <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-4 md:gap-6 pt-1 sm:pt-2 md:pt-3 px-2">
            <div className="flex items-center gap-2 sm:gap-3 text-white bg-white/20 backdrop-blur-md px-4 sm:px-5 md:px-6 py-2 sm:py-2.5 md:py-3 rounded-full shadow-lg">
              <Icon name="Shield" size={20} className="sm:hidden" />
              <Icon name="Shield" size={22} className="hidden sm:block md:hidden" />
              <Icon name="Shield" size={24} className="hidden md:block" />
              <span className="font-semibold text-sm sm:text-base">Plataforma segura y verificada</span>
            </div>
            <div className="flex items-center gap-2 sm:gap-3 text-white bg-white/20 backdrop-blur-md px-4 sm:px-5 md:px-6 py-2 sm:py-2.5 md:py-3 rounded-full shadow-lg">
              <Icon name="Users" size={20} className="sm:hidden" />
              <Icon name="Users" size={22} className="hidden sm:block md:hidden" />
              <Icon name="Users" size={24} className="hidden md:block" />
              <span className="font-semibold text-sm sm:text-base">+100 usuarios activos</span>
            </div>
          </div>

          {/* Scroll indicator */}
          <div className="hidden sm:block absolute bottom-2 sm:bottom-3 md:bottom-4 left-1/2 -translate-x-1/2 animate-bounce">
            <Icon name="ChevronDown" size={28} color="white" className="sm:hidden" />
            <Icon name="ChevronDown" size={32} color="white" className="hidden sm:block" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;